/* ============================================================
   Blueminum Commissions Page JS
   Drop into assets/commissions.js
   ============================================================ */

(function() {
  const commissionsPage = document.querySelector('.commissions-page');
  if (!commissionsPage) return;

  const state = {
    year: '', make: '', model: '',
    size: { price: 0, label: '' }
  };

  function initState() {
    const selectedSize = document.querySelector('#size-cards .radio-card.selected');
    if (selectedSize) {
      state.size = { price: Number(selectedSize.dataset.price), label: selectedSize.dataset.label };
    }
    updateSummary();
  }

  function updateSummary() {
    const sVehicle = document.getElementById('s-vehicle');
    const sVehicleSub = document.getElementById('s-vehicle-sub');
    const sSizeLabel = document.getElementById('s-size-label');
    const sSizePrice = document.getElementById('s-size-price');
    const sTotal = document.getElementById('s-total');
    if (!sVehicle) return;

    const vehicle = [state.year, state.make, state.model].filter(Boolean).join(' ').trim();
    sVehicle.textContent = vehicle || 'Your vehicle';
    sVehicleSub.textContent = vehicle ? 'One-of-one · Premium aluminum' : 'Fill out the form to preview';
    sSizeLabel.textContent = state.size.label;
    sSizePrice.textContent = '$' + state.size.price;
    sTotal.textContent = '$' + state.size.price;
  }

  function bindCards(containerId, stateKey) {
    const cards = document.querySelectorAll('#' + containerId + ' .radio-card');
    cards.forEach(card => {
      card.addEventListener('click', () => {
        cards.forEach(c => c.classList.remove('selected'));
        card.classList.add('selected');
        state[stateKey] = { price: Number(card.dataset.price), label: card.dataset.label };
        updateSummary();
      });
    });
  }

  bindCards('size-cards', 'size');

  ['f-year', 'f-make', 'f-model'].forEach(id => {
    const el = document.getElementById(id);
    if (el) {
      el.addEventListener('input', (e) => {
        state[id.replace('f-', '')] = e.target.value;
        updateSummary();
      });
    }
  });

  // FAQ accordion
  document.querySelectorAll('.faq-question').forEach(q => {
    q.addEventListener('click', () => {
      q.parentElement.classList.toggle('open');
    });
  });

  initState();
})();